import useTeamsAndCountries from './queryHooks/useManagerTeams';

export const useFilterData = () => {
  const { data: configData, refetch: refetchConfig } = useTeamsAndCountries({
    onSuccess: () => {},
    onError: () => {},
  });

  return { configData, refetchConfig };
};
